import { OrderTaskModel } from "./OrderTaskModel";
import PageResponse from "./PageResponseModel";
import { PerformerInfo } from "./PerformerInfo";
import { ZmkTaskModel } from "./ZmkTaskModel";

export default class ZmkTaskPerformerModel {
  Performer!: PerformerInfo;
  TaskList!: Array<OrderTaskModel>;
  TaskPage!: PageResponse;
  PageStep: number = 15;
  constructor(obj?: Partial<ZmkTaskPerformerModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
